import React from "react";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Row,
  OverlayTrigger,
  Tooltip,
  Spinner,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { Label } from "reactstrap";
import { Document, Page, pdfjs } from "react-pdf";
import { showUrlDokumen } from "stores/Pengajuan/function";
import SplitText from "views/SplitText";
import { uploadSlipTakeOver } from "stores/Pengajuan/function";
import { uploadSkl } from "stores/Pengajuan/function";
import { getAllPengajuan } from "stores/Pengajuan/function";
import Swal from "sweetalert2";
import { showUrlDokumenKunjungan } from "stores";
import { ColorRing } from "react-loader-spinner";
const FotoKunjungan = () => {
  const dispatch = useDispatch();
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const allDetail = pengajuan.detailPengajuan;
  const kunjungan = !pengajuan.detailPengajuan.Kunjungan
    ? []
    : pengajuan.detailPengajuan.Kunjungan;
  const stepEnam = !pengajuan.detailPengajuan.stepEnam
    ? []
    : pengajuan.detailPengajuan.stepEnam;
  const [loading, setLoading] = React.useState(true);
  const fotoKunjungan = kunjungan.fotoKunjungan;
  const fotoPencairan = stepEnam.UrlSignedFotoPencairan;

  React.useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <Row>
        <Col md="6" style={{ marginTop: 20 }}>
          <Card.Header>
            <Card.Title
              as="h4"
              style={{
                fontWeight: "bold",
                textTransform: "uppercase",
                textAlign: "center",
              }}
            >
              Foto Kunjungan
              <hr />
            </Card.Title>
          </Card.Header>
          <Card.Body style={{ textAlign: "center" }}>
            {loading ? (
              <div
                className="loader-container"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  width: "100%",
                }}
              >
                <ColorRing
                  visible={true}
                  height="80"
                  width="80"
                  ariaLabel="color-ring-loading"
                  wrapperStyle={{}}
                  wrapperClass="color-ring-wrapper"
                  colors={[
                    "#6c757d",
                    "#6c757d",
                    "#6c757d",
                    "#6c757d",
                    "#6c757d",
                  ]}
                />
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: 19,
                  }}
                ></p>
              </div>
            ) : fotoKunjungan ? (
              <img
                src={fotoKunjungan}
                alt="Foto Kunjungan"
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            ) : (
              <div style={{ textAlign: "center" }}>
                <p
                  style={{
                    fontWeight: "bold",
                    marginBottom: "1rem",
                  }}
                >
                  Maaf, belum ada foto kunjungan saat ini.
                </p>
                <img
                  src={require("assets/img/sorry.jpg").default}
                  alt="Sorry"
                  style={{
                    maxWidth: "20%",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              </div>
            )}
          </Card.Body>
        </Col>
        <Col md="6" style={{ marginTop: 20 }}>
          <Card.Header>
            <Card.Title
              as="h4"
              style={{
                fontWeight: "bold",
                textTransform: "uppercase",
                textAlign: "center",
              }}
            >
              Foto Pencairan
              <hr />
            </Card.Title>
          </Card.Header>
          <Card.Body style={{ textAlign: "center" }}>
            {loading ? (
              <div
                className="loader-container"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  width: "100%",
                }}
              >
                <ColorRing
                  visible={true}
                  height="80"
                  width="80"
                  ariaLabel="color-ring-loading"
                  wrapperStyle={{}}
                  wrapperClass="color-ring-wrapper"
                  colors={[
                    "#6c757d",
                    "#6c757d",
                    "#6c757d",
                    "#6c757d",
                    "#6c757d",
                  ]}
                />
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: 19,
                  }}
                ></p>
              </div>
            ) : fotoPencairan ? (
              <img
                src={fotoPencairan}
                alt="Foto Pencairan"
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            ) : (
              <div style={{ textAlign: "center" }}>
                <p
                  style={{
                    fontWeight: "bold",
                    marginBottom: "1rem",
                  }}
                >
                  Maaf, belum ada foto pencairan saat ini.
                </p>
                <img
                  src={require("assets/img/sorry.jpg").default}
                  alt="Sorry"
                  style={{
                    maxWidth: "20%",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              </div>
            )}
          </Card.Body>
        </Col>
      </Row>
    </>
  );
};

export default FotoKunjungan;
